<modal>
  <b class="uppercase" header>{{(groups.length > 1 ? title : groups[0].key) | lang}}</b>

  <ng-container *ngIf="groups.length > 1">
    <ng-container *ngFor="let group of groups">
      <collapsible *ngIf="group.items.length > 1">
        <b header>{{group.key | lang}}</b>

        <div class="item sticky" (click)="toggle(group.items)">
          <div>
            <span class="bold uppercase text-primary">{{'Tất cả' | lang}}</span>
          </div>
          <i *ngIf="all(group.items)" class="fa fa-check text-primary"></i>
        </div>

        <div class="item" *ngFor="let item of group.items" (click)="toggle([item])">
          <i *ngIf="item.icon" class="{{item.icon}}"></i>
          <div>
            <span class="capitalize">{{item.name}}</span>
            <br />
            <small *ngIf="item.description">{{item.description}}</small>
          </div>
          <i *ngIf="item.selected" class="fa fa-check"></i>
        </div>
      </collapsible>
    </ng-container>
  </ng-container>
  <div *ngIf="groups.length < 2">

    <div *ngIf="groups[0].items.length > 1" class="item sticky" (click)="toggle(groups[0].items)">
      <div>
        <span class="bold uppercase">{{'Tất cả' | lang}}</span>
      </div>
      <i *ngIf="!none(groups[0].items)" [ngClass]="{'opacity-50': some(groups[0].items)}" class="fa fa-check"></i>
    </div>

    <div class="item" *ngFor="let item of groups[0].items" (click)="toggle([item])">
      <i *ngIf="item.icon" class="{{item.icon}}"></i>
      <div>
        <span class="capitalize">{{item.name}}</span>
        <br />
        <small *ngIf="item.description">{{item.description}}</small>
      </div>
      <i *ngIf="item.selected" class="fa fa-check"></i>
    </div>
  </div>

  <div class="std-padding-top std-padding-bottom bg-white sticky">
    <button class="w-100 bg-info text-white" (click)="close()"><span>{{'Chọn xong' | lang}}</span></button>
  </div>
</modal>
